module.exports = __webpack_public_path__ + "img/hammer_p.16019bd6.svg";